import { render, staticRenderFns } from "./kaoZhengManager.vue?vue&type=template&id=60f6c4a2"
import script from "./kaoZhengManager.vue?vue&type=script&lang=js"
export * from "./kaoZhengManager.vue?vue&type=script&lang=js"
import style0 from "./kaoZhengManager.vue?vue&type=style&index=0&id=60f6c4a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports